export default "__VITE_ASSET__C1wIIuYI__"